module.exports = __webpack_public_path__ + "img/6.428344f4.jpg";